export default __webpack_public_path__ + "static/media/img-0591-poland-full-face.9162a59d.png";